<!--
  The private notes under one line of the diff, and the note being written
  there (state/fileNotes.svelte.ts): what a diff view draws in a line's
  inline rows for notes.
-->
<script lang="ts">
  import type { Note } from '../api/server';
  import type { FileNotes } from '../state/fileNotes.svelte';
  import type { NotesStore } from '../state/notes.svelte';
  import type { NotePromote } from '../state/promotion';
  import NoteCard from './NoteCard.svelte';
  import NoteComposer from './NoteComposer.svelte';

  interface Props {
    notes: FileNotes;
    store: NotesStore;
    /** The line's key (`anchorKey`). */
    at: string;
    /** The repository and the pull request on screen, which a promotion's link names. */
    here?: { owner: string; repo: string; number: number | null } | null;
    /** How a note is promoted here (a pull request's page), else none. */
    promoteOf?: (n: Note) => NotePromote | null;
  }
  let { notes, store, at, here = null, promoteOf = () => null }: Props = $props();
</script>

{#each notes.at.get(at) ?? [] as p (p.note.id)}<NoteCard placed={p} {store} {here} promote={promoteOf(p.note)} />{/each}
{#if notes.draft && notes.draftKey === at}
  {#key `${notes.draft.from}-${notes.draft.to}-${notes.draft.failed ?? ''}`}
    <NoteComposer draft={notes.draft} onsave={(text) => void notes.save(text)} onclose={() => notes.close()} />
  {/key}
{/if}
